import React, {useEffect, useState} from 'react';
import {Capacitor} from '@capacitor/core';
import {StatusBar, Style} from '@capacitor/status-bar';
import {useRecoilState, useRecoilValue, useSetRecoilState} from 'recoil';
import {useLocation, useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

import AddContentsBtn from '@/components/community/AddContentsBtn';
import Header from '@/layouts/Header';
import BottomNavigation from '@/layouts/BottomNavigation';
import {
  AddressList,
  CommunityAddressTxt,
  PathHistories,
  isOpenAddressSelector,
} from '@/store';
import AddressSelector from '@/components/community/AddressSelector';
import Layout from '@/layouts';

import CommunityList from './List';
import styles from './styles.module.scss';

export default function Community() {
  const navigator = useNavigate();
  const location = useLocation();
  const addressTxt = useRecoilValue(CommunityAddressTxt);
  const setIsOpen = useSetRecoilState(isOpenAddressSelector);
  const addressList = useRecoilValue(AddressList);
  const [histories, setHistories] = useRecoilState(PathHistories);
  const [isBrandOnly, setIsBrandOnly] = useState(false);
  const {t} = useTranslation(['views'], {keyPrefix: 'community.index'});
  const init = async () => {
    if (Capacitor.getPlatform() !== 'web') {
      StatusBar.setStyle({
        style: Style.Light,
      });
    }
  };

  useEffect(() => {
    init();
    if (location.state?.id) {
      setIsBrandOnly(true);
    } else {
      setIsBrandOnly(false);
    }
  }, [location]);

  return (
    <Layout.Main>
      <div className="community">
        <Header
          title={t('header')}
          isWhite={true}
          isNoRing={true}
          isCommunity={true}
          withBack={isBrandOnly}
          backCallback={() => {
            const _histories = JSON.parse(JSON.stringify(histories));
            _histories.splice(-1, 1);
            if (_histories.length > 0) {
              const {path, state} = _histories[_histories.length - 1];
              console.log(_histories);
              setHistories(_histories);
              setTimeout(() => {
                navigator(`/${path}`, {
                  state,
                });
              }, 0);
            } else {
              navigator('/home');
            }
            // if (location.state?.prev) {
            //   console.log(location.state);
            //   navigator(`/${location.state.prev}`, {
            //     state: {
            //       prev: location.state.postPrev,
            //     },
            //   });
            // } else {
            //   navigator(-1);
            // }
          }}
          titleStyle={{
            fontWeight: isBrandOnly ? '500' : '700',
            fontSize: isBrandOnly ? '18px' : '20px',
          }}>
          {isBrandOnly ? (
            <div style={{cursor: 'default'}}>{location.state?.name}</div>
          ) : (
            <div
              className={`${styles.community_category_selector} ${
                addressTxt !== '지역 전체' ? 'has-val' : ''
              }`}
              onClick={() => setIsOpen(true)}
              style={{cursor: 'pointer'}}>
              <span
                className={`txt ${
                  addressTxt !== '지역 전체' ? styles.hasval : ''
                }`}>
                {addressTxt}
              </span>
              <span
                className={`${styles.icon} ${
                  addressTxt !== '지역 전체'
                    ? 'arrow-down-black-darker-icon'
                    : 'arrow-down-black-icon'
                }`}>
                &nbsp;
              </span>
            </div>
          )}
        </Header>
        <CommunityList />
        <BottomNavigation />
        <AddContentsBtn />
        <AddressSelector addressList={addressList} />
      </div>
    </Layout.Main>
  );
}
